/* src/features/5DD/HistoryView.js */
import React, { useState, useEffect } from 'react';
import { db } from '../../apiClient';
import { format, parseISO } from 'date-fns';
import SummaryView from './SummaryView';

const styles = {
  container: { color: '#fff', padding: '10px', maxWidth: '600px', margin: '0 auto' },
  sectionTitle: { borderBottom: '1px solid #555', paddingBottom: '5px', marginBottom: '15px', color: '#aaa', fontSize: '0.9em', textTransform: 'uppercase' },
  
  // Card Styles
  card: {
    backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px', padding: '15px',
    marginBottom: '15px', cursor: 'pointer', transition: 'background 0.2s', border: '1px solid #333'
  },
  activeCard: {
    backgroundColor: 'rgba(46, 125, 50, 0.15)', borderRadius: '8px', padding: '20px',
    marginBottom: '25px', cursor: 'pointer', border: '1px solid #2e7d32', boxShadow: '0 4px 10px rgba(0,0,0,0.3)'
  },
  
  // Typography
  cardTitle: { margin: '0 0 5px 0', fontSize: '1.2em', color: '#fff' },
  activeTitle: { margin: '0 0 5px 0', fontSize: '1.4em', color: '#ffd700', fontWeight: 'bold' },
  cardMeta: { margin: 0, fontSize: '0.9em', color: '#ccc' },
  statusBadge: {
    fontSize: '0.7em', padding: '2px 6px', borderRadius: '4px',
    marginLeft: '10px', textTransform: 'uppercase', fontWeight: 'bold', verticalAlign: 'middle'
  }
};

function HistoryView({ session, profile }) {
  const [courses, setCourses] = useState([]);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [loading, setLoading] = useState(true);

  // 1. Fetch History Data
  useEffect(() => {
    async function fetchHistory() {
      setLoading(true);
      const data = await db.courses.history();
      setCourses(data || []);
      setLoading(false);
    }
    fetchHistory();
  }, [session.user.id]);

  // 2. RENDER DETAIL VIEW (If selected)
  if (selectedCourseId) {
    return (
      <SummaryView 
        session={session} 
        courseId={selectedCourseId} 
        profile={profile} // <--- CRITICAL: Pass profile for "Jim's Five Days Different" header
        onBack={() => setSelectedCourseId(null)} 
      />
    );
  }

  // 3. LOGIC: Find active course
  // Priority: Database Active > Profile Start Date > None
  const dbActive = courses.find(c => c.is_active === true);
  
																		 
  const virtualActive = !dbActive && profile?.course_start_date ? {
      id: 'current_virtual',
      start_date: profile.course_start_date,
      user_note: 'Current Cycle',
      is_active: true,
      start_weight: profile.weight || '?'
  } : null;

  const activeCourse = dbActive || virtualActive;
  const pastCourses = courses.filter(c => c.is_active !== true);

  return (
    <div style={styles.container}>
      
      {/* SECTION 1: IN PROGRESS */}
      {activeCourse && (
        <>
            <h3 style={styles.sectionTitle}>In Progress</h3>
            <div 
                style={styles.activeCard}
                onClick={() => setSelectedCourseId(activeCourse.id)}
            >
                <h4 style={styles.activeTitle}>
                    {activeCourse.user_note || "Current Cycle"}
                    <span style={{...styles.statusBadge, backgroundColor: '#2e7d32'}}>Active</span>
                </h4>
                <p style={styles.cardMeta}>
                    Started: {format(parseISO(activeCourse.start_date), 'MMMM do')} <br/>
                    Tap to view live progress &rarr;
                </p>
            </div>
        </>
      )}

      {/* SECTION 2: ARCHIVES */}
      <h3 style={styles.sectionTitle}>Archives</h3>
      
      {loading && <p>Loading history...</p>}

      {!loading && pastCourses.length === 0 && (
        <p style={{fontStyle:'italic', color:'#aaa', padding:'10px'}}>No completed courses yet.</p>
      )}

      {pastCourses.map(course => (
          <div key={course.id} style={styles.card} onClick={() => setSelectedCourseId(course.id)}>
            <h4 style={styles.cardTitle}>{course.user_note || "Untitled Cycle"}</h4>
            <p style={styles.cardMeta}>
              {format(parseISO(course.start_date), 'MMM do, yyyy')} &bull; {course.start_weight} &rarr; {course.end_weight || '?'}
            </p>
          </div>
      ))}
    </div>
  );
}

export default HistoryView;